<template>
  <div v-if="shouldShow" class="mobile-bottom-nav-wrapper no-print">
    <div
      v-if="showSheet"
      class="mobile-bottom-nav__overlay"
      @click="closeSheet"
    >
      <div class="mobile-bottom-nav__sheet" dir="rtl" @click.stop>
        <div class="mobile-bottom-nav__sheet-header">
          <button type="button" class="mobile-bottom-nav__sheet-close" @click="closeSheet" aria-label="بستن">
            <i class="fas fa-times"></i>
          </button>
          <span class="mobile-bottom-nav__sheet-title">{{ sheetTitle }}</span>
        </div>
        <ul class="mobile-bottom-nav__sheet-list">
          <li
            v-for="sub in sheetItems"
            :key="sub.id || sub.label"
            :class="{
              'mobile-bottom-nav__sheet-item--header': sub.isHeader,
              'mobile-bottom-nav__sheet-item--link': !sub.isHeader,
              'mobile-bottom-nav__sheet-item--logout': sub.action === 'logout',
            }"
          >
            <div v-if="sub.isHeader" class="mobile-bottom-nav__sheet-group">
              <i v-if="sub.icon" :class="sub.icon" class="mobile-bottom-nav__sheet-group-icon" aria-hidden="true"></i>
              <span class="mobile-bottom-nav__sheet-group-text">{{ sub.label }}</span>
            </div>
            <button
              v-else
              type="button"
              class="mobile-bottom-nav__sheet-link"
              :class="{ 'mobile-bottom-nav__sheet-link--danger': sub.action === 'logout' }"
              @click="handleSheetItemClick(sub)"
            >
              <span
                v-if="sub.isSubMenu"
                class="mobile-bottom-nav__sheet-bullet"
                aria-hidden="true"
              ></span>
              <i v-else-if="sub.icon" :class="sub.icon" aria-hidden="true"></i>
              <span class="mobile-bottom-nav__sheet-link-text">{{ sub.label }}</span>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <nav class="mobile-bottom-nav" dir="rtl" role="navigation" aria-label="منوی پایین">
      <button
        v-for="item in items"
        :key="item.id"
        type="button"
        class="mobile-bottom-nav__item"
        :class="{
          'mobile-bottom-nav__item--active': isActive(item),
        }"
        @click="handleItemClick(item)"
      >
        <span class="mobile-bottom-nav__icon-wrap">
          <i :class="item.icon" aria-hidden="true"></i>
          <span v-if="item.badge > 0" class="mobile-bottom-nav__badge">{{ item.badge }}</span>
        </span>
        <span class="mobile-bottom-nav__label">{{ item.label }}</span>
      </button>
    </nav>
  </div>
</template>

<script>
import { isRouteExcluded, isMobileScreenWidth } from '../../utils/mobileBottomNav'

export default {
  name: 'MobileBottomNav',
  props: {
    variant: {
      type: String,
      default: 'netpa',
      validator: (v) => v === 'netpa',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showSheet: false,
      sheetItems: [],
      sheetTitle: 'بیشتر',
      isMobileViewport: false,
    }
  },
  computed: {
    shouldShow() {
      return this.isMobileViewport && this.items.length > 0 && !isRouteExcluded(this.$route.name)
    },
  },
  watch: {
    shouldShow: {
      immediate: true,
      handler(visible) {
        this.updateBodyClass(visible)
      },
    },
  },
  mounted() {
    this.checkViewport()
    window.addEventListener('resize', this.checkViewport)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkViewport)
    this.updateBodyClass(false)
  },
  methods: {
    checkViewport() {
      this.isMobileViewport = isMobileScreenWidth()
    },
    updateBodyClass(visible) {
      if (visible) {
        document.documentElement.classList.add('has-mobile-bottom-nav')
        document.body.classList.add('has-mobile-bottom-nav')
      } else {
        document.documentElement.classList.remove('has-mobile-bottom-nav')
        document.body.classList.remove('has-mobile-bottom-nav')
      }
    },
    isActive(item) {
      if (item.action === 'more' || item.action === 'menu') {
        return this.showSheet
      }
      if (this.showSheet) {
        return false
      }
      if (!item.routeName) return false

      const routeName = this.$route.name

      if (item.id === 'home') {
        return routeName === 'Home'
      }

      if (item.id === 'loan') {
        return ['loan', 'loanFollowup', 'LoanRequest', 'LoanCardex', 'ListVamRequests'].includes(routeName)
      }

      if (item.id === 'accounts') {
        return ['Accounts', 'Funds'].includes(routeName)
      }

      if (item.id === 'pay') {
        if (routeName !== 'Deposit') return false
        if (!item.params) return true
        const routeTashilat = this.$route.params.IsTashilat
        const itemTashilat = item.params.IsTashilat
        if (routeTashilat !== undefined && String(routeTashilat) !== String(itemTashilat)) {
          return false
        }
        return true
      }

      return routeName === item.routeName
    },
    handleItemClick(item) {
      if (item.action === 'more' || item.action === 'menu') {
        const nextTitle = item.action === 'menu' ? 'منو' : 'بیشتر'
        if (this.showSheet && this.sheetTitle === nextTitle) {
          this.closeSheet()
          return
        }
        this.sheetTitle = nextTitle
        this.sheetItems = item.moreItems || []
        this.showSheet = true
        return
      }
      this.closeSheet()
      this.navigateToItem(item)
    },
    handleSheetItemClick(sub) {
      if (sub.action === 'logout') {
        this.logout()
        return
      }
      if (sub.action === 'gotoModirShobe') {
        this.gotoModirShobe()
        return
      }
      this.navigateToItem(sub)
      this.closeSheet()
    },
    navigateToItem(item) {
      if (item.forceLogin) {
        this.$session.set('ForceLoginpage', true)
      }
      if (item.routeName) {
        const to = { name: item.routeName }
        if (item.params) to.params = item.params
        if (item.query) to.query = item.query
        if (this.$route.name !== item.routeName || item.params) {
          this.$router.push(to)
        }
      }
    },
    logout() {
      const DataAxios = {
        Method: 'Post',
        Action: 'Logout',
        ArryfildValue: {},
        Token: this.$session.get('TokenNetPa'),
      }
      this.$PostData(DataAxios).then(() => {
        this.$store.state.Netpa_Cart = []
        this.$router.push('/')
        this.$session.clear()
        sessionStorage.removeItem('vuex')
        this.$store.state.PanelRout = []
        this.$ResetTimer()
        this.closeSheet()
      })
    },
    gotoModirShobe() {
      this.$session.set('UserInfoNetPa', this.$session.get('UserInfoNetPaModirShobe'))
      this.$session.set('UserInfoNetPaModirShobe', null)
      this.closeSheet()
      if (this.$route.name != 'Home') {
        this.$router.push('/PishkhanNetPa/Home').then(() => window.location.reload())
      } else {
        window.location.reload()
      }
    },
    closeSheet() {
      this.showSheet = false
      this.sheetItems = []
    },
  },
}
</script>

<style scoped>
.mobile-bottom-nav-wrapper {
  display: none;
}

@media (max-width: 767px) {
  .mobile-bottom-nav-wrapper {
    display: block;
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1040;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;
  }

  .mobile-bottom-nav {
    position: relative;
    right: auto;
    left: auto;
    bottom: auto;
    z-index: 2;
    -webkit-tap-highlight-color: transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    height: calc(var(--mobile-bottom-nav-height, 60px) + env(safe-area-inset-bottom, 0px));
    padding: 2px 4px env(safe-area-inset-bottom, 0px);
    background: #2a3f54;
    border-top: 1px solid rgba(243, 137, 5, 0.35);
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.15);
  }

  .mobile-bottom-nav__item {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 2px 0;
    border: none;
    background: transparent;
    color: rgba(255, 255, 255, 0.72);
    cursor: pointer;
    min-width: 0;
    overflow: hidden;
    transition: color 0.15s ease;
    outline: none;
    box-shadow: none;
    -webkit-tap-highlight-color: transparent;
  }

  .mobile-bottom-nav__item:focus,
  .mobile-bottom-nav__item:focus-visible,
  .mobile-bottom-nav__item:active {
    outline: none;
    box-shadow: none;
    border: none;
  }

  .mobile-bottom-nav__item--active .mobile-bottom-nav__icon-wrap {
    background: #f38905;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2px;
    font-size: 16px;
    box-shadow: 0 2px 6px rgba(243, 137, 5, 0.45);
    color: #fff;
  }

  .mobile-bottom-nav__item--active {
    color: #fff;
  }

  .mobile-bottom-nav__item--active .mobile-bottom-nav__label {
    color: #f38905;
  }

  .mobile-bottom-nav__icon-wrap {
    position: relative;
    font-size: 18px;
    line-height: 1;
    flex-shrink: 0;
    overflow: hidden;
  }

  .mobile-bottom-nav__label {
    font-size: 11px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    max-width: 100%;
    line-height: 1.2;
    padding: 0 2px;
    box-sizing: border-box;
  }

  .mobile-bottom-nav__badge {
    position: absolute;
    top: 0;
    right: 0;
    left: auto;
    min-width: 14px;
    height: 14px;
    padding: 0 3px;
    border-radius: 7px;
    background: #c72816;
    color: #fff;
    font-size: 8px !important;
    line-height: 14px;
    text-align: center;
  }

  .mobile-bottom-nav__overlay {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: calc(var(--mobile-bottom-nav-height, 68px) + env(safe-area-inset-bottom, 0px));
    z-index: 1;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: calc(16px + env(safe-area-inset-top, 0px)) 12px 0;
    box-sizing: border-box;
  }

  .mobile-bottom-nav__sheet {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: none;
    overflow-x: hidden;
    overflow-y: auto;
    background: #fff;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.12);
    box-sizing: border-box;
    flex: 1 1 auto;
    min-height: 0;
    text-align: right;
  }

  .mobile-bottom-nav__sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    border-bottom: 1px solid #e8ecf0;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .mobile-bottom-nav__sheet-title {
    flex: 1;
    text-align: right;
    font-size: 15px !important;
    font-weight: bold;
    color: #2a3f54;
  }

  .mobile-bottom-nav__sheet-close {
    flex-shrink: 0;
    border: none;
    background: transparent;
    color: #666;
    font-size: 18px !important;
    padding: 4px 8px;
    cursor: pointer;
    outline: none;
    box-shadow: none;
  }

  .mobile-bottom-nav__sheet-close:focus,
  .mobile-bottom-nav__sheet-close:focus-visible,
  .mobile-bottom-nav__sheet-close:active {
    outline: none;
    box-shadow: none;
    border: none;
  }

  .mobile-bottom-nav__sheet-list {
    list-style: none;
    margin: 0;
    padding: 0 0 12px;
  }

  .mobile-bottom-nav__sheet-group {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;
    padding: 12px 20px 10px;
    font-size: 13px !important;
    font-weight: bold;
    color: #2a3f54;
    text-align: right;
    background: linear-gradient(to left, rgba(243, 137, 5, 0.1), rgba(243, 137, 5, 0.04));
    border-top: 1px solid #e8ecf0;
    border-bottom: 1px solid rgba(243, 137, 5, 0.18);
  }

  .mobile-bottom-nav__sheet-group-icon {
    flex-shrink: 0;
    color: #f38905;
    font-size: 15px !important;
    width: 20px;
    text-align: center;
  }

  .mobile-bottom-nav__sheet-group-text {
    text-align: right;
    line-height: 1.5;
  }

  .mobile-bottom-nav__sheet-item--header:first-child .mobile-bottom-nav__sheet-group {
    border-top: none;
  }

  .mobile-bottom-nav__sheet-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    width: 100%;
    padding: 13px 28px 13px 16px;
    border: none;
    border-bottom: 1px solid #f0f2f5;
    background: #fff;
    text-align: right;
    color: #3d5166;
    font-size: 13px !important;
    cursor: pointer;
    box-sizing: border-box;
  }

  .mobile-bottom-nav__sheet-link-text {
    text-align: right;
    line-height: 1.5;
  }

  .mobile-bottom-nav__sheet-bullet {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
  }

  .mobile-bottom-nav__sheet-bullet::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #f38905;
    opacity: 0.85;
  }

  .mobile-bottom-nav__sheet-link i {
    flex-shrink: 0;
    color: #f38905;
    width: 18px;
    font-size: 14px !important;
    text-align: center;
    opacity: 0.85;
  }

  .mobile-bottom-nav__sheet-link:focus,
  .mobile-bottom-nav__sheet-link:focus-visible,
  .mobile-bottom-nav__sheet-link:active {
    outline: none;
    box-shadow: none;
    border-bottom-color: #f0f2f5;
  }

  .mobile-bottom-nav__sheet-link:active {
    background: #f8f9fb;
  }

  .mobile-bottom-nav__sheet-item--logout {
    margin-top: 8px;
    border-top: 1px solid #e8ecf0;
  }

  .mobile-bottom-nav__sheet-link--danger {
    color: #c72816;
    font-weight: bold;
  }

  .mobile-bottom-nav__sheet-link--danger i {
    color: #c72816;
  }
}
</style>

<style>
@media (max-width: 767px) {
  :root {
    --mobile-bottom-nav-height: 68px;
  }

  body.has-mobile-bottom-nav .right_col {
    padding-bottom: calc(var(--mobile-bottom-nav-height, 68px) + 8px + env(safe-area-inset-bottom, 0px)) !important;
  }

  body.has-mobile-bottom-nav .staticPage {
    padding-bottom: calc(var(--mobile-bottom-nav-height, 68px) + 16px + env(safe-area-inset-bottom, 0px)) !important;
  }

  body.has-mobile-bottom-nav .container-fluid {
    padding-bottom: calc(var(--mobile-bottom-nav-height, 68px) + 8px + env(safe-area-inset-bottom, 0px));
  }

  body.has-mobile-bottom-nav .right_col .container-fluid {
    padding-bottom: 0;
  }

  body.has-mobile-bottom-nav .footer {
    bottom: calc(var(--mobile-bottom-nav-height, 68px) + env(safe-area-inset-bottom, 0px)) !important;
  }

  body.has-mobile-bottom-nav #goTop {
    bottom: calc(var(--mobile-bottom-nav-height, 68px) + env(safe-area-inset-bottom, 0px)) !important;
  }
}
</style>
